// extracted by mini-css-extract-plugin
module.exports = {"articles":"OurBlogSection_articles__4sCEG","articlesSmall":"OurBlogSection_articlesSmall___1YO9","articlesBig":"OurBlogSection_articlesBig__ea7Dx"};